// extracted by mini-css-extract-plugin
export default {"container":"PF-z","innerContainer":"QF-z","multipleLines":"RF-z","heading":"SF-z","content":"TF-z","linkColor":"UF-z"};